import { useState } from 'react'
import { ButtonToolbar, Dropdown } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { useMutation } from '@apollo/client'
import { IFilterOption } from '@rankmi/rankmi-table/dist/interfaces/filterProps'
import { Filters } from '@rankmi/rankmi-table'

import {
  MutationDownloadExternalCourseUsersMonitoringArgs,
  TDataDownloadExternalCourseUsersMonitoring,
  DOWNLOAD_EXTERNAL_COURSE_USERS_MONITORING,
} from 'graphqlAPI'
import { useAccess } from 'contexts/AccessContext'

import { downloadFile } from 'helpers/downloadFile.helper'
import { IAreaModel } from 'models/area.model'
import { buildQuery } from 'helpers'
import { DropdownReport } from 'components/dropdowns/DropdownReport'
import { usePrefixTranslation } from '../../hooks'
import styles from './Buttons.module.scss'

interface ButtonsProps {
  id: string
  filtersColumns: IFilterOption[]
  onChangeFilters: (filters: IAreaModel) => void
  allSelected: boolean
  selected: number[]
  total: number
  area?: IAreaModel | null
  translations?: any
}

export const Buttons = ({
  id,
  filtersColumns,
  onChangeFilters,
  allSelected,
  selected,
  total,
  area,
  translations,
}: ButtonsProps) => {
  const [showFiltersModal, setShowFiltersModal] = useState(false)
  const tRelative = usePrefixTranslation()

  const [downloadExternalCourseUsersMonitoring] = useMutation<
    TDataDownloadExternalCourseUsersMonitoring,
    MutationDownloadExternalCourseUsersMonitoringArgs
  >(DOWNLOAD_EXTERNAL_COURSE_USERS_MONITORING)

  const {
    permissions: { canDownload },
  } = useAccess()

  return (
    <>
      <ButtonToolbar className="float-left">
        <Filters
          columns={filtersColumns}
          onChange={(data: any) => {
            onChangeFilters(data)
          }}
          open={showFiltersModal}
          onVisibilityChange={(state: boolean) => setShowFiltersModal(state)}
          locale={translations}
        />
      </ButtonToolbar>
      <ButtonToolbar className={`float-right ${styles.buttons}`}>
        <Dropdown
          id="dropdown-manage"
          className={styles.dropdownManage}
          alignRight
        >
          <Dropdown.Toggle
            id="dropdown-manage-toggle"
            bsPrefix="noCaret"
            variant={'secondary'}
          >
            {tRelative('statistics.actions.label')}
            <FontAwesomeIcon icon={faChevronDown} />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <DropdownReport
              disabled={!total || !canDownload}
              onClick={async () => {
                const { url } = await downloadExternalCourseUsersMonitoring({
                  variables: {
                    input: {
                      externalCourseId: id,
                      areaId: area?.id?.toString(),
                      q: buildQuery(selected.map(Number), allSelected),
                      perPage: 1000,
                    },
                  },
                }).then(({ data }) => ({
                  ...data?.downloadExternalCourseUsersMonitoring,
                }))
                if (url) downloadFile(url)
              }}
            >
              {tRelative('statistics.actions.options.downloadReportSelected', {
                count: !allSelected
                  ? selected?.length
                  : total - selected.length,
              })}
            </DropdownReport>
          </Dropdown.Menu>
        </Dropdown>
      </ButtonToolbar>
    </>
  )
}
